import { Component, OnInit, Inject, OnChanges, SimpleChanges } from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { NavigationEnd, Router } from "@angular/router";
import { UserSessionService } from "src/app/services/usersession.service";
import swal from "sweetalert2";
import * as _ from "lodash";
import { TranslateService } from "@ngx-translate/core";
import { MatDialog } from "@angular/material/dialog";
import { NavigationService } from "src/app/services/navigation.service";
import { BalanceService } from "src/app/services/balance.service";
import { NgbDropdownConfig } from "@ng-bootstrap/ng-bootstrap";
import { filter } from "rxjs/operators";
import { AuthenticationService } from "src/app/services/authentication.service";
import { environment } from "src/environments/environment";
import * as jwtDecode from 'jwt-decode';
@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"],
  providers: [NgbDropdownConfig]
})
export class NavbarComponent implements OnInit {
  cardNo: string;
  balance: any;
  profileType: any;
  status: any;
  clicked: any;
  cardStatus: boolean = true;
  show: number;
  Webversion: any;
  number: string;
  cardbalance: any;
  auth: any;
  username: any;
  firstname: any;
  email: any;
  lastname: any;
  trackingNumber: any;
  constructor(
    @Inject(DOCUMENT) private document: Document,
    public translate: TranslateService,
    private usersessionService: UserSessionService,
    private navigationService: NavigationService,
    private router: Router,
    public dialog: MatDialog,
    private balanceService: BalanceService,
    private authService: AuthenticationService,
    config: NgbDropdownConfig
  ) {
    this.cardNo = this.usersessionService.cardNumber()
    this.trackingNumber = this.usersessionService.trackingNumber()
    config.placement = 'right-top';
    config.autoClose = true;
    this.Webversion = localStorage.getItem('webserverversion')
  }

  ngOnInit() {
    this.getBalance();
    this.clicked = 1;
    this.balanceService.getCardStatusObs().subscribe(() => {
      let cardStatus = sessionStorage.getItem('cardStatus');
      this.cardStatus = cardStatus === 'allocated' ? true : false;
    })

    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      if (event.url === '/dashboard') {
        this.clicked = 1
      } if (event.url === '/transaction') {
        this.clicked = 2;
      } if (event.url === '/smssetup') {
        this.clicked = 3;
      } if (event.url === '/blockcard') {
        this.clicked = 4;
      } if (event.url === '/wallettransfer') {
        this.clicked = 5;
      }

    });
  }

  onLogouts() {
    localStorage.removeItem("isLoggedin");
    this.userauditupdate();
    this.removeLocalStorageData();
    if (!localStorage.getItem("isLoggedin")) {
      this.router.navigate(["/auth/login"]);
    }
  }

  userauditupdate() {
    this.auth = this.usersessionService.authToken()
    const decodedToken: any = jwtDecode(this.auth);
    this.username = decodedToken.username

    const auditdata = {
      username: this.username,
    }
  }

  removeLocalStorageData() {
    localStorage.removeItem("menu");
    localStorage.removeItem('eGramam-' + environment.apiBaseUrl + '-AuthData');
    localStorage.removeItem("fromdate");
    localStorage.removeItem("fromdate_val");
    localStorage.removeItem("otpStatus");
    localStorage.removeItem("status");
    localStorage.removeItem("toDate");
    localStorage.removeItem("menuClient");
    localStorage.removeItem("clientChange");
    localStorage.removeItem("roleID");
    localStorage.removeItem("resellerId");
    localStorage.removeItem("clientChangeID");
    localStorage.removeItem("data1");
    localStorage.removeItem("clientId");
    localStorage.removeItem("todate_val");
    localStorage.removeItem("deptId");
    sessionStorage.removeItem("email");
    sessionStorage.removeItem("mobile");
    sessionStorage.removeItem("otp_to");
    sessionStorage.removeItem("clientId");


  }

  getBalance() {
    var data =
    {
      'cardNo': this.trackingNumber
    }
    this.balanceService.getBalance(data).subscribe(res => {
      this.balance = res.resultString.total_balance
      this.profileType = res.resultString.profile_type
      this.firstname = res.resultString.firstname
      this.email = res.resultString.email
      this.lastname = res.resultString.lastname
      this.getStatus()

    })
  }
  getStatus() {
    var data = {
      'cardno': this.trackingNumber,
      'profile_type': this.profileType
    }
    this.balanceService.getStatus(data).subscribe((res) => {
      this.status = res.resultString.status;
    })
  }
  gotoDashboard() {
    this.clicked = 1;
    this.navigationService.goToDashboard()
  }

  gotoBlockcard() {
    this.clicked = 4;
    this.navigationService.gotoBlockCard();
  }

  goToWalletTransfer() {
    this.clicked = 5;
    this.navigationService.goToWalletTransfer();
  }

  gotoTranscation() {
    this.clicked = 2;
    this.router.navigate(['transaction']);
  }

  gotoWallet() {
    this.router.navigate(['wallet']);
  }

  gotosmssetup() {
    this.clicked = 3;
    this.router.navigate(['smssetup']);
  }

  gotoStatement() {
    this.navigationService.gotoStatement();
  }

  notShow() {
    this.show = 1
  }

  clickNavi() {
    this.router.navigateByUrl('/transaction', { skipLocationChange: true }).then(() => {
      this.gotoTranscation();
    });
  }

  toggleSidebar(e) {
    e.preventDefault();
    this.document.body.classList.toggle("sidebar-open");
  }

  onLogout(e) {
    e.preventDefault();
    const title = this.translate.instant("Would you like to logout?");
    const Yes = this.translate.instant("Yes");
    const No = this.translate.instant("No");
    swal
      .fire({
        title,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: Yes,
        cancelButtonText: No,
      })
      .then((result) => {
        if (result.value) {
          e.preventDefault();
          localStorage.removeItem("isLoggedin");
          if (!localStorage.getItem("isLoggedin")) {
            this.router.navigate(["/auth/login"]);
        }
        }
      });
  }

}
